
export const SET_COMPLIANCE_SELECTED_TASK = "SET_COMPLIANCE_SELECTED_TASK"
export const SET_COMPLIANCE_TASK_STATUS = "SET_COMPLIANCE_TASK_STATUS"
export const SET_COMPLIANCE_VERSION_HISTORY = "SET_COMPLIANCE_VERSION_HISTORY"
